"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLedgerEntry = exports.classifyOrderEventLedger = exports.buildOrderEventLedgerFields = exports.WalletActions = exports.StripePlans = exports.PromoCodeDuration = exports.PaymentTypes = exports.PaymentSettings = exports.PaymentOptionsTypes = exports.OrderPaymentTypes = exports.LedgerKinds = exports.LEDGER_TAXONOMY = exports.CashFlag = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PaymentSettings = exports.PaymentSettings = {
  NoPayments: 'off',
  OnlineOnly: 'on',
  Optional: 'on,off',
  Membership: 'membership'
};
var PaymentTypes = exports.PaymentTypes = {
  Membership: 'membership',
  Card: 'card'
};
var OrderPaymentTypes = exports.OrderPaymentTypes = {
  NotPaid: 'notPaid',
  FullyPaid: 'fullyPaid',
  PartiallyPaid: 'partiallyPaid',
  PaidWithMembership: 'paidWithMembership',
  PricedZero: 'pricedZero'
};
var StripePlans = exports.StripePlans = {
  Free: 0,
  Grow: 1,
  Video: 2,
  AllInOne: 3
};
var PromoCodeDuration = exports.PromoCodeDuration = {
  forever: 'forever',
  repeating: 'repeating',
  once: 'once'
};
var PaymentOptionsTypes = exports.PaymentOptionsTypes = {
  ServiceOnsite: 'serviceOnsite',
  ServiceOnline: 'serviceOnline',
  ServiceMembership: 'serviceMembership',
  CourseOnsite: 'courseOnsite',
  CourseOnline: 'courseOnline',
  CourseMembership: 'courseMembership',
  MembershipOnsite: 'membershipOnsite',
  MembershipOnline: 'membershipOnline'
};
var WalletActions = exports.WalletActions = {
  activation: 'activation',
  payment: 'payment',
  reimburse: 'reimburse',
  topup: 'topup',
  decrease: 'decrease',
  promotion: 'promotion' // free credit loaded by the provider — NOT cash in (→ credit_grant)
};

// ─── Canonical money ledger (financial-ledger FIN) ───────────────────────────
// The single source of truth for the ledger taxonomy. Every writer and
// LedgerService.post validate against LEDGER_TAXONOMY. `cashFlag` drives revenue
// (only 'cash' counts as revenue); `sign` is the expected sign of amount_cents;
// `reverses` (when set) means the entry must carry reverses_entry_id.

var CashFlag = exports.CashFlag = {
  cash: 'cash',
  credit: 'credit',
  none: 'none'
};

// Ledger kinds = the order_event_type enum values. `payment` (sale) and `refund`
// pre-exist; the credit/* kinds were added by migration 009. Commission/payout
// kinds are added by their lanes (AFF/LED) when needed.
var LedgerKinds = exports.LedgerKinds = {
  payment: 'payment',
  refund: 'refund',
  creditGrant: 'credit_grant',
  creditConsumption: 'credit_consumption',
  creditTopup: 'credit_topup',
  reimbursement: 'reimbursement',
  creditWriteoff: 'credit_writeoff' // LED-2: membership expiry write-off
};

// Cash flow (revenue) comes ONLY from `payment` and `credit_topup`. Refunds in this
// business do NOT return money (no Stripe money-back) — they restore the ORIGINAL
// credit store, so they are NON-cash. The destination depends on how the item was paid
// (captured by membership_id vs wallet_id on the entry):
//   - membership-paid → restores the MEMBERSHIP session count  (reimbursement)
//   - wallet-paid     → restores the WALLET balance            (reimbursement)
//   - cash-paid       → adds WALLET credit; the cash stays as a deferred liability (credit_grant)
// The cash-negative `refund` kind is RESERVED for a future real Stripe money-back and is
// not used today.
var LEDGER_TAXONOMY = exports.LEDGER_TAXONOMY = {
  payment: {
    cashFlag: CashFlag.cash,
    sign: 1,
    reverses: null
  },
  // purchase → cash in
  credit_topup: {
    cashFlag: CashFlag.cash,
    sign: 1,
    reverses: null
  },
  // wallet top-up (incl. via payment Link) → cash in
  credit_consumption: {
    cashFlag: CashFlag.credit,
    sign: -1,
    reverses: null
  },
  // pay with membership/wallet → no cash, spends credit
  credit_grant: {
    cashFlag: CashFlag.none,
    sign: 1,
    reverses: null
  },
  // refund of a cash payment → wallet credit (deferred liability)
  reimbursement: {
    cashFlag: CashFlag.none,
    sign: 1,
    reverses: 'credit_consumption'
  },
  // refund of a credit payment → credit back to membership count or wallet
  refund: {
    cashFlag: CashFlag.cash,
    sign: -1,
    reverses: 'payment'
  },
  // RESERVED: real Stripe money-back (not used today)
  credit_writeoff: {
    cashFlag: CashFlag.none,
    sign: -1,
    reverses: null
  } // LED-2: membership expires with unused counter balance
};

// Returns null when the entry is valid, otherwise a human-readable reason.
var validateLedgerEntry = exports.validateLedgerEntry = function validateLedgerEntry(_ref) {
  var kind = _ref.kind,
    cashFlag = _ref.cashFlag,
    amountCents = _ref.amountCents,
    reversesEntryId = _ref.reversesEntryId;
  var taxon = LEDGER_TAXONOMY[kind];
  if (!taxon) return "unknown ledger kind: ".concat(kind);
  if (cashFlag !== taxon.cashFlag) return "cash_flag '".concat(cashFlag, "' contradicts kind '").concat(kind, "' (expected '").concat(taxon.cashFlag, "')");
  if (!Number.isInteger(amountCents)) return "amount_cents must be an integer (got ".concat(amountCents, ")");
  if (taxon.sign > 0 && amountCents < 0) return "kind '".concat(kind, "' must not be negative");
  if (taxon.sign < 0 && amountCents > 0) return "kind '".concat(kind, "' must not be positive");
  if (taxon.reverses && !reversesEntryId) return "kind '".concat(kind, "' requires reverses_entry_id (reverses '").concat(taxon.reverses, "')");
  return null;
};

// Legacy `method` → ledger classification (design §6). Returns { kind, cashFlag,
// sign } or null when there is no money movement to record (FREE / unknown).
// Used to derive ledger fields for order_event writers that don't pass them.
var classifyOrderEventLedger = exports.classifyOrderEventLedger = function classifyOrderEventLedger(method, type) {
  if (type === LedgerKinds.refund) return {
    kind: LedgerKinds.refund,
    cashFlag: CashFlag.cash,
    sign: -1
  };
  var m = String(method || '').toLowerCase();
  if (m === 'wallet' || m === 'membership') return {
    kind: LedgerKinds.creditConsumption,
    cashFlag: CashFlag.credit,
    sign: -1
  };
  if (['creditcard', 'debitcard', 'cash', 'banktransfer', 'stripe'].includes(m)) return {
    kind: LedgerKinds.payment,
    cashFlag: CashFlag.cash,
    sign: 1
  };
  return null;
};

// Derive the canonical ledger fields for an order_event from the legacy inputs
// (method, type, euro price/paid). PURE — no DB. This is the single classification
// used by EVERY order_event writer (Stripe settlement, the manual "mark as paid" UI,
// video/bundle/workout purchases), so money the business receives through a
// NON-integrated channel — cash, POS, card terminal, bank transfer — is counted as
// cash_flag='cash' just like Stripe. Wallet/membership stay credit (not revenue).
// Explicit ledger fields (e.g. the settlement's authoritative Stripe cents) win;
// FREE/unknown method or zero amount → the request is returned unchanged (legacy-only
// row). Amount derives from the float euro price/paid (catalog amounts are floats).
var buildOrderEventLedgerFields = exports.buildOrderEventLedgerFields = function buildOrderEventLedgerFields(request) {
  var _ref2, _request$paid;
  if (request.amountCents !== undefined || request.cashFlag !== undefined) {
    return request; // caller already classified (authoritative)
  }
  var cls = classifyOrderEventLedger(request.method, request.type);
  var euros = (_ref2 = (_request$paid = request.paid) !== null && _request$paid !== void 0 ? _request$paid : request.price) !== null && _ref2 !== void 0 ? _ref2 : 0;
  if (!cls || !euros) {
    return request; // no money movement to record
  }
  var amountCents = cls.sign * Math.round(Math.abs(euros) * 100);
  var reason = validateLedgerEntry({
    kind: cls.kind,
    cashFlag: cls.cashFlag,
    amountCents: amountCents,
    reversesEntryId: request.reversesEntryId
  });
  if (reason) {
    return request; // invalid classification → degrade to a legacy-only row
  }
  return cls.cashFlag === CashFlag.cash ? _objectSpread(_objectSpread({}, request), {}, {
    type: cls.kind,
    cashFlag: cls.cashFlag,
    amountCents: amountCents,
    netCents: amountCents,
    taxCents: 0,
    grossCents: amountCents
  }) : _objectSpread(_objectSpread({}, request), {}, {
    type: cls.kind,
    cashFlag: cls.cashFlag,
    amountCents: amountCents
  });
};
